export default {
    // 指令的定义
    mounted(el, binding, vNode) {
        el.addEventListener("wheel", (event) => {
            event.preventDefault();
            el.style.scrollBehavior = 'smooth';
            el.scrollLeft += event.deltaY * 3;
        }, { passive: false });
    },
}
